/**
 * Copyright (c) 2023 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Florian Hartl <f.hartl@techdivision.com>
 */

import { checkoutConfig } from '../RootComponents/Checkout/config';
import { studioLocatorConfig } from '../RootComponents/StudioLocator/config';

/**
 * Dynamic Component Injection Configuration
 * @type {{checkout: {content: {component: string, params: {stepData}}}}}
 */
export const componentsConfig = {
  checkout: checkoutConfig,
  studioLocator: studioLocatorConfig,
};
